import type { PageLoad } from './$types';

export const load = (async ({ params, parent, url }) => {
	const { hubId, api, respSessionHubUser } = await parent();
	if (!respSessionHubUser) return;

	const collectionSlug = params.collection;
	const tag = url.searchParams.get('tag') ?? undefined;

	const postsFilters = {
		collectionSlug,
		tag,
		types: ['post', 'widgetHtml', 'widgetQuickPoll', 'widgetLink'],
		statuses: ['published'],
	};
	const respPosts = await api.getPosts({
		hubId,
		filters: postsFilters,
		page: { page: 1, size: 16 },
	});
	return {
		respPosts,
		postsFilters,
	};
}) satisfies PageLoad;
